import { Product, ProductCardPriceRange } from "../../types/types";
import { PriceRange } from "@~/types/prodcatBaseTypes";
import { determinePriceRange } from "../__shared__/PriceUtils/priceUtils";

export const transformVariantPriceRange = (
  variantPriceRange: PriceRange,
): ProductCardPriceRange => {
  const { value, reductionHistory } = variantPriceRange;

  const price: ProductCardPriceRange = {
    was: "",
    then1: "",
    then2: "",
    now: determinePriceRange(value ?? ""),
  };

  if (reductionHistory) {
    if (reductionHistory[0]?.display)
      price.was = determinePriceRange(reductionHistory[0].display);
    if (reductionHistory[1]?.display)
      price.then1 = determinePriceRange(reductionHistory[1].display);
    if (reductionHistory[2]?.display)
      price.then2 = determinePriceRange(reductionHistory[2].display);
  }

  return price;
};

export const isPriceAtLeastMinimumThreshold = (
  price: ProductCardPriceRange | null | undefined,
): boolean => {
  if (!price) return false;

  // Some special order items have a non-fixed price that is initially keyed as a
  // value below 5p and then updated to the correct price once the order is placed.
  // We want to hide the price of these products on the PLP.
  return price.now >= "0.05";
};

export function getCreditMessage(
  price: ProductCardPriceRange,
  product: Product,
): string | undefined {
  if (!product.credit) return undefined;

  if (typeof price.now === "string" || !price.now.from) {
    if (product.credit.illustration) {
      const { financialProductType, repaymentAmount, creditRate } =
        product.credit.illustration;

      if (financialProductType === "IBC") {
        return `From ${repaymentAmount.display} a month ${creditRate.display} APR*`;
      }
      if (financialProductType === "IFC") {
        return `From ${repaymentAmount.display} a month interest free*`;
      }
    }
  } else if (product.credit.available) {
    return "Payment plans available";
  }

  return undefined;
}
